import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import PageHeader from "../../Components/PageHeader/PageHeader";

const SUPPORT_WHATSAPP_NUMBER = "+201200000000"; // update if you store it elsewhere

const Contact = () => {
  const navigate = useNavigate();
  const encodedMsg = useMemo(
    () => encodeURIComponent("Hello Dijla, I would like to inquire."),
    []
  );
  const phoneDigits = useMemo(
    () => SUPPORT_WHATSAPP_NUMBER.replace(/[^\d]/g, ""),
    []
  );

  const openWhatsApp = () => {
    const webFallback = `https://wa.me/${phoneDigits}?text=${encodedMsg}`;
    window.open(webFallback, "_blank");
  };

  const openInquiryForm = () => {
    navigate("/contact/inquiry");
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="Contact Us"
        subtitle="Get in touch with our support team. We're here to help with all your clearing and forwarding needs."
      />

      <div className="max-w-7xl mx-auto px-6 py-8 md:py-12">
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          <button
            onClick={openWhatsApp}
            className="group flex items-start gap-4 border-2 border-gray-200 rounded-xl p-6 md:p-8 bg-white hover:bg-gray-50 hover:border-green-500 transition-all"
          >
            <span className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-green-100 group-hover:bg-green-200 transition-colors">
              <span role="img" aria-label="chat" className="text-2xl">
                💬
              </span>
            </span>
            <div className="text-left flex-1">
              <h3 className="font-semibold text-lg text-gray-900 mb-2">
                WhatsApp Chat
              </h3>
              <p className="text-gray-600">
                Get instant support through WhatsApp. Our team is available to
                answer your questions.
              </p>
              <p className="text-sm text-green-600 font-medium mt-3">
                Start chat →
              </p>
            </div>
          </button>

          <button
            onClick={openInquiryForm}
            className="group flex items-start gap-4 border-2 border-gray-200 rounded-xl p-6 md:p-8 bg-white hover:bg-gray-50 hover:border-blue-500 transition-all"
          >
            <span className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-blue-100 group-hover:bg-blue-200 transition-colors">
              <span role="img" aria-label="mail" className="text-2xl">
                ✉️
              </span>
            </span>
            <div className="text-left flex-1">
              <h3 className="font-semibold text-lg text-gray-900 mb-2">
                Send Inquiry
              </h3>
              <p className="text-gray-600">
                Fill out our contact form and we'll get back to you within 24
                hours.
              </p>
              <p className="text-sm text-blue-600 font-medium mt-3">
                Fill form →
              </p>
            </div>
          </button>
        </div>

        <div className="mt-12 bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-8 max-w-4xl mx-auto">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">
            Business Hours
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h3 className="font-medium text-gray-700 mb-2">Office Hours</h3>
              <p className="text-gray-600">
                Sunday - Thursday: 9:00 AM - 5:00 PM
              </p>
              <p className="text-gray-600">Friday - Saturday: Closed</p>
            </div>
            <div>
              <h3 className="font-medium text-gray-700 mb-2">
                Support Response Time
              </h3>
              <p className="text-gray-600">WhatsApp: Within 2 hours</p>
              <p className="text-gray-600">Email: Within 24 hours</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
